export enum BonusTypeEnum {
    FromGGR = 1,
    FromDeposit = 2
}
